import { ActionContext, Module } from 'vuex'
import { RootState, RouterParamsState } from './state_models'

export const routerParams: Module<RouterParamsState, RootState> = {
    namespaced: true,
    state: {
        smartList: '',
        smartListSpecs: null,
        previousState: null
    },
    getters: {
        getSmartList: (state: RouterParamsState) => {
            return state.smartList
        },
        getSmartListSpecs: (state: RouterParamsState) => {
            return state.smartListSpecs
        },
        getPreviousState: (state: RouterParamsState) => {
            return state.previousState
        }
    },
    mutations: {
        setSmartList: (state: RouterParamsState, smartList: string) => {
            state.smartList = smartList
        },
        setSmartListSpecs: (state: RouterParamsState, smartListSpecs: { [key: string]: any }) => {
            state.smartListSpecs = smartListSpecs
        },
        setPreviousState: (state: RouterParamsState, previousState: { [key: string]: any }) => {
            state.previousState = previousState
        }
    },
    actions: {
        setSmartList: (context: ActionContext<RouterParamsState, RootState>, smartList: string) => {
            context.commit('setSmartList', smartList)
        },
        setSmartListSpecs: (context: ActionContext<RouterParamsState, RootState>, smartListSpecs: { [key: string]: any }) => {
            context.commit('setSmartListSpecs', smartListSpecs)
        },
        setPreviousState: (context: ActionContext<RouterParamsState, RootState>, previousState: { [key: string]: any }) => {
            context.commit('setPreviousState', previousState)
        },
        resetRouteParamsState: (context: ActionContext<RouterParamsState, RootState>) => {
            context.commit('setSmartList', '')
            context.commit('setSmartListSpecs', null)
            context.commit('setPreviousState', null)
        }
    }
}